// components/Pagamentos/NovoPagamentoModal.js
import React, { useState } from "react";
import Modal from "react-modal";
import styles from "./NovoPagamentoModal.module.css";
import { useNotification } from "../../hooks/useNotification";

const NovoPagamentoModal = ({ isOpen, onClose, onSave }) => {
  const initialState = {
    studentId: "",
    serviceType: "",
    reference: "",
    amount: "",
    classe: "",
  };

  const [paymentData, setPaymentData] = useState(initialState);
  const { notifyError, notifySuccess } = useNotification();

  // 🔹 Buscar dados da referência
 const fetchReference = async (reference) => {
  try {
    const res = await fetch(`/api/referencias/${reference}`);
    const json = await res.json();
    const data = json.data;

    if (res.ok && data) {
      let codigoAluno = data.codigo_aluno;
      let classeAluno = data.classe;

      // 🔥 SE VIER DE PAGAMENTOS (MATRÍCULA)
      if (!codigoAluno && data.aluno_id) {
        const alunoRes = await fetch(`/api/alunos/${data.aluno_id}`);
        const alunoJson = await alunoRes.json();

        console.log("👤 Dados do aluno:", alunoJson);

        if (alunoRes.ok && alunoJson) {
          codigoAluno = alunoJson.codigo_aluno;
          classeAluno = alunoJson.classe;
        }
      }

      setPaymentData((prev) => ({
        ...prev,
        amount: data.valor || 0,
        studentId: codigoAluno || "",
        serviceType: data.tipo_servico || "",
        classe: classeAluno || "",
      }));
    } else {
      notifyError("❌ Referência não encontrada.");
    }
  } catch (err) {
    console.error(err);
    notifyError("❌ Erro ao buscar referência.");
  }
};
  // 🔹 Criar pagamento
  const handleCreatePayment = async () => {
    if (
      !paymentData.studentId.trim() ||
      !paymentData.serviceType.trim() ||
      !paymentData.reference.trim() ||
      !paymentData.classe.trim()
    ) {
      notifyError("⚠️ Preencha todos os campos obrigatórios.");
      return;
    }

    try {
      const response = await fetch("/api/pagamentos", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_aluno: paymentData.studentId.trim(),
          tipo_servico: paymentData.serviceType.trim(),
          referencia: paymentData.reference.trim(),
          valor: paymentData.amount,
          classe: paymentData.classe.trim(),
          metodo_pagamento: "MANUAL",
          status: "pago",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        notifySuccess(data.message || "✅ Pagamento registrado com sucesso!");
        if (onSave && data.pagamento) onSave(data.pagamento);
        handleCancel();
      } else {
        notifyError(data.message || "❌ Erro ao registrar pagamento.");
      }
    } catch (err) {
      console.error("Erro ao registrar pagamento:", err);
      notifyError("❌ Erro ao conectar ao servidor.");
    }
  };

  const handleCancel = () => {
    setPaymentData(initialState);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCancel}
      className={styles.filterModal}
      overlayClassName={styles.modalOverlay}
    >
      <h2>Registrar Pagamento</h2>
      <div className={styles.modalContent}>
        <label>
          Código do Aluno: <span className={styles.required}>*</span>
          <input
            type="text"
            value={paymentData.studentId}
            readOnly
            className={styles.shortInput}
          />
        </label>

        <label>
          Tipo de Serviço: <span className={styles.required}>*</span>
          <input
            type="text"
            value={paymentData.serviceType}
            readOnly
            className={styles.shortInput}
          />
        </label>

        <label>
          Classe: <span className={styles.required}>*</span>
          <input
            type="text"
            value={paymentData.classe}
            readOnly
            className={styles.shortInput}
          />
        </label>

        <label>
          Referência: <span className={styles.required}>*</span>
          <input
            type="text"
            placeholder="Ex: 772025000211"
            value={paymentData.reference}
            onChange={(e) => {
              const ref = e.target.value;
              setPaymentData({ ...paymentData, reference: ref });

              if (ref.length >= 6) {
                fetchReference(ref);
              }
            }}
            className={styles.shortInput}
          />
        </label>

        <label>
          Valor (MZN):
          <input
            type="number"
            value={paymentData.amount}
            readOnly
            className={styles.shortInput}
          />
        </label>

        <div className={styles.buttonsContainer}>
          <button className={styles.applyFilter} onClick={handleCreatePayment}>
            Registrar Pagamento
          </button>
          <button
            className={styles.cancelButton}
            onClick={handleCancel}
            type="button"
          >
            Cancelar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NovoPagamentoModal;